import React from "react";

function ViewButton() {
  return (
    <svg
      width="352"
      height="44"
      viewBox="0 0 352 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_2205_1621)">
        <rect width="352" height="44" rx="22" fill="#4072C8" />
        <path
          d="M168.244 15.8636V27.5H166.119L161.057 20.1761H160.972V27.5H158.511V15.8636H160.67L165.693 23.1818H165.795V15.8636H168.244ZM174.209 27.6705C173.311 27.6705 172.538 27.4886 171.891 27.125C171.247 26.7576 170.75 26.2386 170.402 25.5682C170.054 24.8939 169.879 24.0966 169.879 23.1761C169.879 22.2784 170.054 21.4905 170.402 20.8125C170.75 20.1345 171.241 19.6061 171.874 19.2273C172.51 18.8485 173.256 18.6591 174.112 18.6591C174.688 18.6591 175.224 18.7519 175.72 18.9375C176.22 19.1193 176.656 19.3939 177.027 19.7614C177.402 20.1288 177.694 20.5909 177.902 21.1477C178.11 21.7008 178.214 22.3485 178.214 23.0909V23.7557H170.845V22.2557H175.936C175.936 21.9072 175.86 21.5985 175.709 21.3295C175.557 21.0606 175.347 20.8504 175.078 20.6989C174.813 20.5436 174.504 20.4659 174.152 20.4659C173.785 20.4659 173.459 20.5511 173.175 20.7216C172.894 20.8883 172.675 21.1136 172.516 21.3977C172.357 21.678 172.275 21.9905 172.271 22.3352V23.7614C172.271 24.1932 172.351 24.5663 172.51 24.8807C172.673 25.1951 172.902 25.4375 173.197 25.608C173.493 25.7784 173.843 25.8636 174.249 25.8636C174.518 25.8636 174.764 25.8258 174.987 25.75C175.211 25.6742 175.402 25.5606 175.561 25.4091C175.72 25.2576 175.841 25.072 175.925 24.8523L178.163 25C178.05 25.5379 177.817 26.0076 177.464 26.4091C177.116 26.8068 176.665 27.1174 176.112 27.3409C175.563 27.5606 174.929 27.6705 174.209 27.6705ZM181.661 18.7727L183.263 21.8239L184.905 18.7727H187.388L184.859 23.1364L187.456 27.5H184.984L183.263 24.483L181.57 27.5H179.07L181.661 23.1364L179.161 18.7727H181.661ZM193.467 18.7727V20.5909H188.212V18.7727H193.467ZM189.405 16.6818H191.825V24.8182C191.825 25.0417 191.859 25.2159 191.928 25.3409C191.996 25.4621 192.09 25.5473 192.212 25.5966C192.337 25.6458 192.481 25.6705 192.643 25.6705C192.757 25.6705 192.871 25.661 192.984 25.642C193.098 25.6193 193.185 25.6023 193.246 25.5909L193.626 27.392C193.505 27.4299 193.335 27.4735 193.115 27.5227C192.895 27.5758 192.628 27.608 192.314 27.6193C191.731 27.642 191.219 27.5644 190.78 27.3864C190.344 27.2083 190.005 26.9318 189.763 26.5568C189.52 26.1818 189.401 25.7083 189.405 25.1364V16.6818Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_2205_1621"
          x="0"
          y="-1"
          width="352"
          height="45"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0 0.278431 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2205_1621"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default ViewButton;
